<mat-icon title="Download" (click)="exportAsXLSX()">get_app</mat-icon>